<div class="dialog__wrapper">
  <div class="dialog__header" mat-dialog-title>
    <h4 class="dialog__title">{{ data.organisation }}</h4>
    <button mat-dialog-close mat-icon-button>
      <mat-icon mat-button class="icon" fontIcon="close"></mat-icon>
    </button>
  </div>
  <mat-dialog-content class="dialog__content">
    @if (dataSource$ | async; as dataSource) {
      <table mat-table [dataSource]="dataSource" *ngIf="!isFetching">
        <ng-container matColumnDef="senderIDtext">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sender ID Text</th>
          <td mat-cell *matCellDef="let element">
            <a routerLink="/sender-ids/{{element.senderIdID}}" (click)="handleClose()">{{ element.senderIDText }}</a>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element">
            <span [siStatus]="element">
              {{ element.statusDesc }}
            </span>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>

        <tr *matNoDataRow>
          <td colspan="2">Organisation Sender ID Text list is empty</td>
        </tr>
      </table>
    }

    <div class="dialog__spinner">
      <div *comSpinner="isFetching; color: 'primary'; diameter: 30"></div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="handleClose()">Close</button>
  </mat-dialog-actions>
</div>
